<template>
  <div class="wrap" v-if="visible">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style scoped>
.wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 15vmin;
  height: 15vmin;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 2vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

@-webkit-keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loader {
  border-width: 1vmin;
  border-style: solid;
  border-color: transparent transparent rgba(255, 255, 255, 0.7)
    rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  display: block;
  width: 8vmin;
  height: 8vmin;
  -webkit-animation: rotate 1.5s linear infinite;
  animation: rotate 1.5s linear infinite;
}
</style>